<template>
  <!-- TITLE CONTAINER -->
  <standard-container
    :title="header == '' ? $t('schedule.title') : header"
    footer-height="120px"
  >
    <template v-slot:title>
      <!--
      <div class="mr-2">
        <dialog-schedule-alert 
          :players-selected="playersSelected"
          :disable-add="disableAdd"
          @add-schedule="alertSchedule"
        />
      </div>
      -->
      <div class="mr-2">
        <v-btn
          id="btn-calendar"
          fab
          small
          :disabled="disableAdd"
          :players-selected="playersSelected"
          @click="openCalendar"
        >
          <v-icon>mdi-calendar</v-icon>
        </v-btn>
      </div>
      <div class="mr-2">
        <dialog-preview-schedule
          :is-btn-disabled="isDisabled()"
          :players-selected="playersSelected"
        />
      </div>
      <div class="mr-2">
        <v-btn
          id="btn-upload"
          :class="hasChanged == true ? 'animate' : ''"
          fab
          small
          :title="$t('schedule.update')"
          :disabled="isDisabled()"
          @click="uploadSchedule()"
        >
          <v-icon>mdi-upload</v-icon>
        </v-btn>
      </div>
      <div>
        <dialog-new-schedule
          :players-selected="playersSelected"
          :disable-add="disableAdd"
          @add-schedule="addSchedule"
        />
      </div>
    </template>
    <!-- CONTENT CONTAINER -->
    <template v-slot:content>
      <v-container fluid>
        <v-row>
          <draggable
            v-model="scheduleModel"
            class="list-group"
          >
            <schedule-grid-item
              v-for="(schedule, index) in scheduleModel"
              :key="index"
              :schedule="schedule"
              :while-time="whileTime"
              :project="schedule.projectData"
              :selected-player.sync="view"
              @refresh="refresh"
            />
          </draggable>
        </v-row>
      </v-container>
    </template>

    <template v-slot:footer>
      <v-container fluid>
        <!-- Projects not in all selected players -->
        <v-row class="outer">
          <v-col
            v-hscroll
            class="inner"
          >
            <v-btn
              v-for="schedule in scheduleUnshared"
              :key="schedule.proj_id"
              class="mr-4"
              @click="setIconOn(schedule.name)"
            >
              {{ schedule.path }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="1"
            class="text-center"
          >
            <v-btn
              fab
              small
              :title="$t('schedule.loop-lock')"
              :disabled="isDisabled()"
              @click="lockTime()"
            >
              <v-icon>{{ timeLock }}</v-icon>
            </v-btn>
          </v-col>
          <v-col
            class="py-0"
            cols="3"
          >
            <v-text-field
              v-model="loopTime"
              :label="$t('schedule.loop-time')"
              type="number"
            />
          </v-col>
          <v-col>
            <v-alert
              v-if="scheduleUnshared.length > 0"
              type="info"
              dense
              outlined
            >
              {{ $t("schedule.warn-loop-lock") }}
            </v-alert>
          </v-col>
          <v-col
            cols="1"
            offset
            align="right"
          >
            <button-dialog-delete
              :icon-mdi="getIconwithScheduleList"
              :icon-only="true"
              :icon-xl="true"
              :is-button-disabled="getDisabledwithPlayer"
              :no-text="true"
              :text="$t('popup.empty-schedule')"
              @ok-pushed="deleteAll()"
            />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </standard-container>
</template>

<script>
// Components
import buttonDialogDelete from "../Common/ButtonDialogDelete";
import standardContainer from "../Common/StandardContainer";
import dialogPreviewSchedule from "../Dialog/DialogPreviewSchedule";
import dialogNewSchedule from "../Dialog/DialogNewSchedule";
//import dialogScheduleAlert from '../Dialog/DialogScheduleAlert';
import scheduleGridItem from "./ScheduleGridItem";
import draggable from "vuedraggable";

// Connectors
import { ScheduleConnector } from "../Database/ScheduleConnector";
import { has } from "remove-accents";

export default {
  components: {
    standardContainer,
    dialogPreviewSchedule,
    dialogNewSchedule,
    buttonDialogDelete,
    //dialogScheduleAlert,
    scheduleGridItem,
    draggable,
  },
  props: {
    hasChanged: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      default: "",
    },
    disableAdd: {
      type: Boolean,
      default: false,
    },
    playersSelected: {
      type: Array,
      default: () => [],
    },
    scheduleList: {
      type: Array,
      default: () => [],
    },
    scheduleListFull: {
      type: Array,
      default: () => [],
    },
    whileTime: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      scheduleConnector: new ScheduleConnector(this.$store.state.user),
      timeLock: "mdi-lock-open-outline",
      loopLimited: false,
      preview: false,
      loopTime: "",
      scheduleArray: [],
      view: {},
      item: {
        path: "",
        mime: "zip",
        name: "",
      },
      calendarVisible: false,
    };
  },
  computed: {
    getIconwithScheduleList() {
      if ((this.scheduleList.length == 0 && this.scheduleListFull.length == 0) || this.playersSelected.length == 0) {
        return "mdi-delete-empty-outline";
      } else {
        return "mdi-delete";
      }
    },
    getDisabledwithPlayer() {
      const writeSchedule = this.$store.state.user.permissions.indexOf(6) !== -1;
      if (
        (this.scheduleList.length == 0 && this.scheduleListFull.length == 0) ||
        this.playersSelected.length == 0 ||
        !writeSchedule
      ) {
        return true;
      } else {
        return false;
      }
    },
    scheduleModel: {
      get() {
        if (this.scheduleList.length > 0) {
          const loop_limit = this.scheduleList[0].loop_limit;
          const loop_duration = this.scheduleList[0].loop_duration;

          this.updateLoopLimit(loop_limit, loop_duration);
        }

        return this.scheduleList;
      },
      set(val) {
        this.scheduleArray = val;
        this.$emit("update:scheduleList", val);
      },
    },
    scheduleUnshared: {
      get() {
        return this.scheduleListFull;
      },
      set(val) {
        this.$emit("update:schedule-list-full", val);
      },
    },
    hasProjectDataNotFound() {
      return this.scheduleList.some((schedule) => schedule.projectData && schedule.projectData.not_found);
    },
  },
  watch: {
    view: function (val) {
      this.item = val;
    },
    scheduleList: {
      handler(val) {
        if (val) {
          this.scheduleArray = val;
          this.$emit("update:scheduleList", val);
          this.isDisabled();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.scheduleArray = this.scheduleList;
  },
  methods: {
    addSchedule(val) {
      this.$emit("scheduleAdded", val);
    },
    refresh() {
      this.$emit("refresh");
    },
    lockTime() {
      if (this.loopLimited) {
        this.timeLock = "mdi-lock-open-outline";
        this.loopTime = "";

        this.loopLimited = !this.loopLimited;
      } else {
        if (this.loopTime != "") {
          this.timeLock = "mdi-lock";
          this.loopLimited = !this.loopLimited;
        }
      }

      const loopState = {
        state: this.loopLimited,
        time: this.loopTime,
      };
      this.$emit("loopState", loopState);
    },
    updateLoopLimit(isLimited, duration) {
      this.loopLimited = isLimited;
      this.loopTime = duration;

      if (!this.loopLimited) {
        this.timeLock = "mdi-lock-open-outline";
        this.loopTime = "";
      } else {
        this.timeLock = "mdi-lock";
      }
    },
    uploadSchedule() {
      const loopState = {
        state: this.loopLimited,
        time: this.loopTime,
      };

      this.$emit("uploadSchedule", loopState);
    },
    isDisabled() {
      const writeSchedule = this.$store.state.user.permissions.indexOf(6) !== -1;

      if (this.scheduleList.some((schedule) => schedule.projectData && schedule.projectData.not_found)) {
        return true;
      }

      if (
        this.scheduleList.length > 0 &&
        (this.loopTime > 0 || this.loopTime == "") &&
        !this.disableAdd &&
        writeSchedule
      )
        return false;
      else return true;
    },
    setIconOn(player) {
      if (player.length !== undefined) {
        player = [player];
      } else {
        player = Object.values(player);
      }

      this.$emit("iconOn", player);
    },
    alertSchedule(val) {
      this.$emit("alertSchedule", val);
    },
    deleteAll() {
      this.$emit("empty-schedule");
    },
    openCalendar() {
      this.calendarVisible = !this.calendarVisible;
      this.$emit("open-calendar", this.calendarVisible);
    },
  },
};
</script>

<style scoped>
.list-group {
  width: 100%;
}

.list-group > .col {
  display: inline-block;
}

.outer {
  width: 100%;
}

.inner {
  overflow: hidden;
  white-space: nowrap;
}

#btn-upload.animate {
  animation: color-loop 3s infinite ease-out;
}

@keyframes color-loop {
  0% {
    background-color: inherit;
  }
  50% {
    background-color: #fb8c00;
  }
  100% {
    background-color: inherit;
  }
}
</style>
